import { useParams, Navigate } from 'react-router-dom';
import ItemRow from '../components/ItemRow';
import ItemActionButton from '../components/ItemActionButton';
import Paginated from '../components/Paginated';
import BackButton from '../components/BackButton';
import useAuth from '../contexts/useAuth';
import type { ListData } from '../../../types';

const AOTD_PLAYLIST_ID = 'aotd-playlist';

const Category = () => {
  const { name } = useParams<{ name: string }>();
  const { user } = useAuth();
  const isAdmin = user?.isAdmin;

  // Redirect "article of the day" category to the AOTD playlist
  if (name && decodeURIComponent(name).toLowerCase() === 'article of the day') {
    return <Navigate to={`/id/${AOTD_PLAYLIST_ID}`} replace />;
  }

  // Format title: decode and capitalize
  const title = name
    ? decodeURIComponent(name)
        .split(' ')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ')
    : '';

  return (
    <div className="page">
      <p className="section-title" style={{ marginTop: '20px' }}>
        {title}
      </p>
      <BackButton />
      <div style={{ marginTop: '20px' }}>
        <Paginated<ListData>
          route={`/api/category/${encodeURIComponent(name || '')}`}
          render={(item) => (
            <div
              key={`category-${item.id}`}
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                paddingRight: '10px',
              }}
            >
              <div style={{ flex: 1, minWidth: 0 }}>
                <ItemRow data={item} isAdmin={isAdmin} />
              </div>
              <ItemActionButton item={item} />
            </div>
          )}
          emptyMessage="No items in this category"
        />
      </div>
    </div>
  );
};

export default Category;
